import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import BlogPage from './pages/BlogPage';
import BlogPost from './pages/BlogPost';
import PurviewAuditPage from './pages/PurviewAuditPage';
import CaseStudiesPage from './pages/CaseStudiesPage';
import DataGovernancePage from './pages/DataGovernancePage';
import ComplianceManagementPage from './pages/ComplianceManagementPage';
import DataLossPreventionPage from './pages/DataLossPreventionPage';
import InformationProtectionPage from './pages/InformationProtectionPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/data-governance" element={<DataGovernancePage />} />
            <Route path="/compliance-management" element={<ComplianceManagementPage />} />
            <Route path="/data-loss-prevention" element={<DataLossPreventionPage />} />
            <Route path="/information-protection" element={<InformationProtectionPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/purview-audit" element={<PurviewAuditPage />} />
            <Route path="/case-studies" element={<CaseStudiesPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;